import clsx from 'clsx'

interface IconProps {
  icon: React.FC<React.SVGProps<SVGSVGElement>>
  size?: number
  fill?: string
  color?: string
  className?: string
  onClick?: () => void
  style?: React.CSSProperties
}

export const Icon = ({
  icon: IconSvg,
  size = 20,
  fill = 'transparent',
  color = 'currentColor',
  className,
  onClick,
  style,
}: IconProps) => {
  return (
    <IconSvg
      width={size}
      height={size}
      fill={fill}
      className={clsx(className)}
      style={{ color, ...style }}
      onClick={onClick}
    />
  )
}
